import React from 'react';
import { History } from 'history';
import { useHistory } from 'react-router-dom';
import { MdArrowBack } from 'react-icons/md';
import { Col, Row } from 'antd';

export interface AuthHeaderProps {
  headerTitle: string;
}

export const AuthHeader: React.FC<AuthHeaderProps> = ({ headerTitle }) => {
  const history: History = useHistory();
  const goBack = (): void => {
    history.goBack();
  };
  return (
    <Row className="authentication-header">
      <Col flex="50px">
        <button onClick={goBack}>
          <MdArrowBack color="#fff" size={32} />
        </button>
      </Col>
      <Col className="title">{headerTitle}</Col>
    </Row>
  );
};
